import { render, staticRenderFns } from "./NewVersionToast.vue?vue&type=template&id=112b14aa&scoped=true"
import script from "./NewVersionToast.vue?vue&type=script&lang=js"
export * from "./NewVersionToast.vue?vue&type=script&lang=js"
import style0 from "./NewVersionToast.vue?vue&type=style&index=0&id=112b14aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112b14aa",
  null
  
)

export default component.exports